<template>
  <div style="background: #f5f5f5 !important">
    <div class="title-section" style="display: flex">
      <h1 class="title title-ruban">CONNEXION</h1>
    </div>
    <div class="page-seperate"></div>

    <div class="columns is-mobile is-centered">
      <div class="column is-one-quarter">
        <div class="has-text-right" style="margin-top: 0.5rem">
          <router-link :to="{ name: 'register' }"
            >Nouvel utilisateur?</router-link
          >
        </div>
        <div class="has-text-right" style="margin-top: 0.5rem">
          <router-link :to="{ name: 'lostPassword' }"
            >Mot de passe oublié?</router-link
          >
        </div>
        <p v-if="this.status != null" class="has-text-danger">
          Identifiant ou mot de passe incorrect
        </p>
        <form @submit.prevent="login" custom-class="required">
          <b-field label="Email">
            <b-input
              type="email"
              v-model="email"
              ref="email"
              class="full-width"
            />
          </b-field>
          <b-field label="Mot de passe">
            <b-input
              type="password"
              v-model="password"
              ref="password"
              password-reveal
              required
            />
          </b-field>

          <!-- <div class="has-text-left" style="margin-top: 0.5rem">
          <router-link :to="{ name: 'lostPassword' }"
            >Mot de passe oublié?</router-link
          >
        </div>-->

          <b-button
            native-type="submit"
            name="button "
            style="
              margin-left: 50%;
              margin-right: 0%;
              margin-top: 1rem;
              margin-bottom: 0.5rem;
            "
            :loading="isLoading"
            class="is-primary"
          >
            Connexion
          </b-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { onUserLogged } from "../../services/dbService";

export default {
  name: "LoginUser",
  data() {
    return {
      email: "",
      password: "",
      status: null,
      isLoading: false,
      url: "",
    };
  },

  methods: {
    login() {
      this.isLoading = true;
      const auth = getAuth();
      const firebaseErrors = {
        "auth/user-not-found": "Utilisateur ou mot de passe incorrect",
        "auth/email-already-in-use": "Compte utilisateur déjà existant",
      }; // list of firebase error codes to alternate error messages
      signInWithEmailAndPassword(auth, this.email, this.password)
        .then((userCreditential) => {
          onUserLogged(userCreditential.user).then(async (is_su) => {
            //  var suResult = await isSu(userCreditential.user);
            // this.$store.dispatch("updateIsSu", suResult).then(() => {
            // mise à jour des varaible hasResult/hasSurvey pour le dashboard
            this.$store.dispatch("updateUserDashboard").then(() => {
              this.$nextTick(() => {
                if (is_su == true) this.$router.push({ name: "Campaigns" });
                else this.$router.push({ name: "Dashboard" });
              });
            });
            //  });
          });
        })
        .catch((err) => {
          this.error = firebaseErrors[err.code];
          this.isLoading = false;
        });
    },
  },
};
</script>
